import React, { useState, useEffect } from "react";
import ParallaxTilt from "react-parallax-tilt";
import { useInView } from "react-intersection-observer";
import usePageMeta from "../../hooks/usePageMeta"; // 1. Import hook
import "./HomePage.css";

const images = [
  "/hero1.jpg",
  "/hero2.jpg",
  "/hero3.jpg",
  "/hero4.jpg",
  "/hero5.jpg",
];
const headline = "TjWit Media";
const testimonials = [
  {
    quote:
      "Tyler is able to capture moments that show the grit and determination of athletes in every sport...",
    author: "Kristin Waltz",
  },
  {
    quote:
      "Tyler is a fabulously talented sports photographer! He consistently captures images of teams, team spirit, leadership...",
    author: "Kim Weas",
  },
  {
    quote:
      "What sets Tyler apart is his professionalism... His attention to detail, both in his work and presentation, is truly commendable.",
    author: "Regina Yanics",
  },
];

const AnimatedCard = ({ children, delay = 0 }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <div
      ref={ref}
      className={`testimonial-card ${inView ? "is-visible" : ""}`}
      style={{ transitionDelay: `${delay}s` }}
    >
      {" "}
      {children}{" "}
    </div>
  );
};

function HomePage() {
  // 2. Set page title and description
  usePageMeta(
    "TjWit Media | Home",
    "Professional sports, commercial, and lifestyle photography serving the Tampa and St. Louis areas. Capturing powerful, professional imagery."
  );

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 7000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="hero-container">
        {images.map((src, index) => (
          <img
            key={src}
            src={src}
            alt={`Background slide ${index + 1}`}
            className={`carousel-image ${
              index === currentIndex ? "active" : ""
            }`}
          />
        ))}
        <div className="hero-overlay"></div>
        <ParallaxTilt
          className="tilt-wrapper"
          tiltMaxAngleX={5}
          tiltMaxAngleY={5}
          perspective={1000}
          transitionSpeed={1500}
          gyroscope={true}
          trackOnWindow={true}
        >
          <div className="hero-content">
            <h1>
              {" "}
              {headline.split("").map((letter, index) => (
                <span
                  key={index}
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  {" "}
                  {letter === " " ? "\u00A0" : letter}{" "}
                </span>
              ))}{" "}
            </h1>
            <p>Where Professionalism Meets Passion</p>
          </div>
        </ParallaxTilt>
      </div>
      <section className="testimonials-section">
        <h2>What My Clients Are Saying</h2>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <AnimatedCard key={index} delay={index * 0.2}>
              <p className="testimonial-text">"{testimonial.quote}"</p>
              <p className="testimonial-author">- {testimonial.author}</p>
            </AnimatedCard>
          ))}
        </div>
      </section>
    </>
  );
}
export default HomePage;
